import { Component } from '@angular/core';

@Component({
  selector: 'app-migration-link',
  templateUrl: './migration-link.component.html',
  styleUrls: ['./migration-link.component.scss']
})
export class MigrationLinkComponent {

}
